import script from "./PeripheralEquipmentIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeripheralEquipmentIcon.vue?vue&type=script&setup=true&lang=ts"

import "./PeripheralEquipmentIcon.vue?vue&type=style&index=0&id=358bd988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358bd988"]])

export default __exports__